export default __webpack_public_path__ + "static/media/art_wheel_bg.23a40b5a.svg";